import { render } from "./device-form.vue?vue&type=template&id=31e1ac4a"
import script from "./device-form.vue?vue&type=script&lang=js"
export * from "./device-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__